export enum EMethod {
  GET = 'GET',
  POST = 'POST',
}

export interface IOuterRequest {
  method: EMethod;
  body?: string;
  url: string;
}

export function outerRequest<T>({ method, body, url }: IOuterRequest): Promise<T> {
  const xhr = new XMLHttpRequest();

  return new Promise((resolve, reject) => {
    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(JSON.parse(xhr.response));
      } else {
        reject();
      }
    };

    xhr.onerror = () => reject();

    xhr.open(method, url);
    xhr.send(body);
  });
}
